import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';
import { ScrollToService } from 'shared/base/scroll-to.service';
import { SearchPageService } from 'shared/search-page/search-page.service';
import { ListManagerService } from 'shared/list-manager/list-manager.service';
import { SideDrawerService } from 'shared/sidedrawer/sidedrawer.service';

import { DigitalAssetsPanelModule } from '../digital-assets-panel/digital-assets-panel.module';
import { DigitalAssetsRoutingModule } from './digital-assets-routing.module';
import { DigitalAssetsComponent } from './digital-assets.component';
import { PublishModalComponent } from './components/publish-modal/publish-modal.component';
import { DigitalAssetsSearchService } from './search/digital-assets-search.service';
import { ContextualActionModule } from './components/contextual-actions/contextual-action.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    DigitalAssetsRoutingModule,
    ContextualActionModule,
    DigitalAssetsPanelModule,
  ],
  declarations: [DigitalAssetsComponent, PublishModalComponent],
  exports: [DigitalAssetsComponent, PublishModalComponent],
  providers: [
    ScrollToService,
    SearchPageService,
    DigitalAssetsSearchService,
    SideDrawerService,
  ]
})
export class DigitalAssetsModule {}
